import {Api} from '../Common/rest-api/api-exports';

export const getOrders = (data) => {
    return Api.Orders.list(data).then(res => res.body).catch(error => error);
};

export const getOrderDetails = (id) => {
    return Api.Orders.details(id).then(res => res.body).catch(error => error);
};

export const setOrderStatus = (id, status) => {
    return Api.Orders.status(id, status).then(res => res.body).catch(error => error);
}

export const getStatusMessage = (id, status) => {
    return Api.Orders.getStatusMessage(id, status).then(res => res.body).catch(error => error);
}

export const updateOrder = (id, data) => {
    return Api.Orders.update(id, data).then(res => res.body).catch(error => error);
}



// WEBPACK FOOTER //
// ./src/customModules/Orders/epics-orders.js